import { render, staticRenderFns } from "./StoreManageTable.vue?vue&type=template&id=ca6b2db0"
import script from "./StoreManageTable.vue?vue&type=script&lang=js"
export * from "./StoreManageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports